import React, { FunctionComponent } from 'react'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons'

import { IProps } from './IProps'
import { ButtonContainer, FilterIcon } from './style'

export const FilterButton: FunctionComponent<IProps> = ({ onClick, categoryFilter }) => {

    return (
        <ButtonContainer onClick={() => onClick()}>
            { categoryFilter ? <FilterIcon icon={faEyeSlash}/> : null }
        </ButtonContainer>
    )
}
